export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/double-arr-down-9c1e5a5457776a69f7f533c3abeb6420.svg";